import styled from 'styled-components'

export const Container = styled.table`
  font-family: sans-serif;
  width: 100%;
  padding-top: 5rem;
  overflow-x: auto;
  white-space: nowrap;

  tr {
    min-width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;

    > th {
      width: 83px;
      padding: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      > p {
        transform: rotate(-90deg);
        padding-left: 10px;
        text-align: left;
        width: inherit;
      }

      &:first-child {
        width: 128px;
      }
    }

    > td {
      margin: 4px;
      width: 75px;
      min-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      > span {
        font-family: 'Roboto';
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
`

export const MessageContainer = styled.tr`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h1 {
    color: #cccccc;
    font-family: 'Roboto';
  }
`
